import { render, staticRenderFns } from "./Home3Dian7.vue?vue&type=template&id=0d53e5e6&scoped=true"
import script from "./Home3Dian7.vue?vue&type=script&lang=js"
export * from "./Home3Dian7.vue?vue&type=script&lang=js"
import style0 from "./Home3Dian7.vue?vue&type=style&index=0&id=0d53e5e6&prod&scoped=true&lang=css"
import style1 from "./Home3Dian7.vue?vue&type=style&index=1&id=0d53e5e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53e5e6",
  null
  
)

export default component.exports